<section class="path-master-page">
  <header class="page-header app-card">
    <div>
      <h1>{{ title() }}</h1>
    </div>
    <button
      type="button"
      class="app-button app-button--primary"
      (click)="openCreateForm()"
    >
      ＋ Add New
    </button>
  </header>



  <section class="hierarchy app-card">
    <h2>Hierarchy Overview</h2>
    <div class="hierarchy-scroll">
      <div class="hierarchy-grid" #networkCanvas (click)="clearNetworkSelection()">
        <svg class="network-lines" aria-hidden="true">
          <defs>
            <marker
              id="network-line-arrow"
              markerWidth="8"
              markerHeight="8"
              refX="7"
              refY="4"
              orient="auto"
              markerUnits="userSpaceOnUse"
            >
              <path d="M 0 0 L 8 4 L 0 8 z" class="network-lines__arrow" />
            </marker>
            <marker
              id="network-line-arrow-highlighted"
              markerWidth="8"
              markerHeight="8"
              refX="7"
              refY="4"
              orient="auto"
              markerUnits="userSpaceOnUse"
            >
              <path d="M 0 0 L 8 4 L 0 8 z" class="network-lines__arrow network-lines__arrow--highlighted" />
            </marker>
          </defs>
          @for (line of networkLines(); track line.source + line.target) {
            <g [class.network-lines__edge--dimmed]="isNetworkEdgeDimmed(line)">
              <path
                [attr.d]="networkPath(line)"
                [attr.marker-end]="networkMarker(line)"
                [class.network-lines__path--highlighted]="isNetworkEdgeHighlighted(line)"
              />
              <g
                class="network-lines__flow-arrow"
                [class.network-lines__flow-arrow--highlighted]="isNetworkEdgeHighlighted(line)"
                [attr.transform]="networkFlowArrowTransform(line)"
              >
                <circle r="8"></circle>
                <path d="M -3 -3 L 2 0 L -3 3"></path>
              </g>
            </g>
          }
        </svg>
        <div class="node-column pss">
          <h3>PSS (Owned by)</h3>
          @for (pss of hierarchyPss(); track pss.code) {
            <button type="button" class="node" [attr.data-network-node]="networkNodeId('pss', pss.code)" [class.node--muted]="!isNetworkNodeHighlighted(networkNodeId('pss', pss.code))" (mouseenter)="setHoveredNetworkNode(networkNodeId('pss', pss.code))" (mouseleave)="setHoveredNetworkNode(null)" (click)="$event.stopPropagation(); selectNetworkNode(networkNodeId('pss', pss.code))">
              ⚡
              <span
                >{{ pss.name
                }}<small
                  >{{ pss.code }} · {{ pathCountForPss(pss.code) }} mapped
                  Path</small
                ></span
              >
            </button>
          }
        </div>
        <div class="node-column links">
          <h3>Feeders</h3>
          @for (link of pathData().links; track link.code) {
            <button type="button" class="node" [attr.data-network-node]="networkNodeId('link', link.code)" [class.node--muted]="!isNetworkNodeHighlighted(networkNodeId('link', link.code))" (mouseenter)="setHoveredNetworkNode(networkNodeId('link', link.code))" (mouseleave)="setHoveredNetworkNode(null)" (click)="$event.stopPropagation(); selectNetworkNode(networkNodeId('link', link.code))">
              {{ link.name
              }}<small
                >{{ pssName(link.pssCode) }} →
                {{ pathNameForLink(link.code) }}</small
              >
            </button>
          }
        </div>
        <div class="node-column paths">
          <h3>Beyond Path</h3>
          @for (path of rows(); track path.id) {
            <button type="button" class="node" [attr.data-network-node]="networkNodeId('path', path.id)" [class.node--muted]="!isNetworkNodeHighlighted(networkNodeId('path', path.id))" (mouseenter)="setHoveredNetworkNode(networkNodeId('path', path.id))" (mouseleave)="setHoveredNetworkNode(null)" (click)="$event.stopPropagation(); selectNetworkNode(networkNodeId('path', path.id))">
              {{ path.name
              }}<small>{{ pssName(path.pssCode) }} · {{ path.code }}</small>
            </button>
          }
        </div>
        <div class="node-column districts">
          <h3>District</h3>
          @for (district of hierarchyDistricts(); track district) {
            <button type="button" class="node" [attr.data-network-node]="networkNodeId('district', district)" [class.node--muted]="!isNetworkNodeHighlighted(networkNodeId('district', district))" (mouseenter)="setHoveredNetworkNode(networkNodeId('district', district))" (mouseleave)="setHoveredNetworkNode(null)" (click)="$event.stopPropagation(); selectNetworkNode(networkNodeId('district', district))">{{ district }}</button>
          }
        </div>
        <div class="node-column flows">
          <h3>Flow Area (via Contracts)</h3>
          @for (flow of hierarchyFlowAreas(); track flow) {
            <button type="button" class="node" [attr.data-network-node]="networkNodeId('flow', flow)" [class.node--muted]="!isNetworkNodeHighlighted(networkNodeId('flow', flow))" (mouseenter)="setHoveredNetworkNode(networkNodeId('flow', flow))" (mouseleave)="setHoveredNetworkNode(null)" (click)="$event.stopPropagation(); selectNetworkNode(networkNodeId('flow', flow))">{{ flow }}</button>
          }
        </div>
      </div>
    </div>
    <aside class="key-points">
      <h3>Key Points</h3>
      <p>
        ◉ Each Link belongs uniquely to one PSS; a PSS can have multiple Links.
      </p>
      <p>◉ Multiple Links can merge into shared regional Paths.</p>
      <p>◉ Paths and Districts, then Districts and Flow Areas, are many-to-many.</p>
    </aside>
  </section>

  <section class="table-card app-card">
    <nav class="tabs" aria-label="Path master views">
      <button
        type="button"
        [class.active]="activeTab() === 'link'"
        (click)="selectTab('link')"
      >
        Link List</button
      ><button
        type="button"
        [class.active]="activeTab() === 'path'"
        (click)="selectTab('path')"
      >
        Path List</button
      ><button
        type="button"
        [class.active]="activeTab() === 'district'"
        (click)="selectTab('district')"
      >
        District List</button
      ><button
        type="button"
        [class.active]="activeTab() === 'flow'"
        (click)="selectTab('flow')"
      >
        Flow Area List
      </button>
    </nav>
    <div class="toolbar" role="search">
      <label class="filter-field">
        <span>Search Path</span>
        <input
          class="app-form-input"
          type="search"
          aria-label="Search paths"
          placeholder="Enter path ID / name / PSS / purpose"
          [value]="searchTerm()"
          (input)="updateSearch($any($event.target).value)"
        />
      </label>
      <div class="filter-actions">
        <button
          type="button"
          class="app-button app-button--secondary"
          (click)="updateSearch('')"
        >
          Reset
        </button>
      </div>
    </div>
    @if (toast()) {
      <div class="toast-message" role="status">{{ toast() }}</div>
    }
    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>Path ID</th>
            <th>Path Name</th>
            <th>PSS Name</th>
            <th>Feeders</th>
            <th>District</th>
            <th>Contract(s)</th>
            <th>Flow Area(s)</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          @for (row of filteredRows(); track row.id) {
            <tr>
              <td>{{ row.id }}</td>
              <td>{{ row.name }}</td>
              <td>{{ pssName(row.pssCode) }}</td>
              <td>{{ linkNames(row.linkCodes) }}</td>
              <td>{{ row.districts.join(", ") }}</td>
              <td>
                @for (contract of contractsFor(row); track contract.id) {
                  <span class="contract-chip"
                    >{{ contract.buyerName }} ·
                    {{ contract.contractType }}</span
                  >
                }
              </td>
              <td>{{ flowAreasFor(row).join(", ") || "—" }}</td>
              <td>
                <span
                  class="status-pill"
                  [class.inactive]="row.status === 'Inactive'"
                  >{{ row.status }}</span
                >
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="8" class="empty-state">No paths found.</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </section>

  @if (isFormOpen()) {
    <div class="modal-backdrop" (click)="closeForm()">
      <section
        class="path-modal app-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="path-modal-title"
        (click)="$event.stopPropagation()"
      >
        <header class="modal-header">
          <div>
            <h2 id="path-modal-title">Add Path</h2>
            <p>
              Register an evacuation network beyond the immediate network for a
              PSS.
            </p>
          </div>
          <button
            type="button"
            class="modal-close"
            (click)="closeForm()"
            aria-label="Close add path form"
          >
            ×
          </button>
        </header>
        <form [formGroup]="form" (ngSubmit)="save()">
          <section>
            <h3>Path Information</h3>
            <div class="form-grid three">
              <label
                >PSS <b>*</b
                ><select class="app-form-select" formControlName="pssCode">
                  <option value="">Select PSS</option>
                  @for (pss of availablePssOptions(); track pss.code) {
                    <option [value]="pss.code">{{ pss.name }}</option>
                  }
                </select></label
              ><label
                >Path Name <b>*</b
                ><input
                  class="app-form-input"
                  formControlName="name"
                  placeholder="Enter Path Name" /></label
              ><label
                >Path Code <b>*</b
                ><input
                  class="app-form-input"
                  formControlName="code"
                  placeholder="Enter Path Code" /></label
              ><label
                >Path Description <b>*</b
                ><textarea
                  class="app-form-input"
                  formControlName="description"
                  placeholder="Enter Path Description"
                ></textarea></label
              ><label
                >PSS Owner <b>*</b
                ><select class="app-form-select" formControlName="owner">
                  <option value="">Select PSS Owner</option>
                  @for (owner of pathData().owners; track owner) {
                    <option [value]="owner">{{ owner }}</option>
                  }
                </select></label
              ><label
                >Path Status <b>*</b
                ><span class="radio-row"
                  ><input
                    type="radio"
                    formControlName="status"
                    value="Active"
                  />
                  Active
                  <input
                    type="radio"
                    formControlName="status"
                    value="Inactive"
                  />
                  Inactive</span
                ></label
              >
            </div>
          </section>
          <section>
            <h3>Mapping Details</h3>
            <div class="form-grid two">
              <div class="form-field">
                District(s) <b>*</b>
                <details
                  class="multi-select"
                  [open]="isMultiSelectOpen('districts')"
                  (toggle)="setMultiSelectOpen('districts', $any($event.target).open)"
                  (focusout)="closeMultiSelectOnFocusOut('districts', $event)"
                >
                  <summary>{{ districtSelectionLabel() }}</summary>
                  <div class="multi-select__menu">
                    @for (district of pathData().districts; track district) {
                      <label
                        ><input
                          type="checkbox"
                          [checked]="
                            form.controls.districts.value.includes(district)
                          "
                          (change)="
                            toggleDistrict(
                              district,
                              $any($event.target).checked
                            )
                          "
                        /><span>{{ district }}</span></label
                      >
                    }
                  </div>
                </details>
                <small>Choose one or more districts</small>
              </div>
              <div class="form-field">
                Link(s) (Immediate Network) <b>*</b>
                @if (selectedPssCode()) {
                  <details
                    class="multi-select"
                    [open]="isMultiSelectOpen('links')"
                    (toggle)="setMultiSelectOpen('links', $any($event.target).open)"
                    (focusout)="closeMultiSelectOnFocusOut('links', $event)"
                  >
                    <summary>{{ linkSelectionLabel() }}</summary>
                    <div class="multi-select__menu">
                      @for (link of linksForPss(); track link.code) {
                        <label
                          ><input
                            type="checkbox"
                            [checked]="
                              form.controls.linkCodes.value.includes(link.code)
                            "
                            (change)="
                              toggleLink(link.code, $any($event.target).checked)
                            "
                          /><span>{{ link.name }}</span></label
                        >
                      }
                    </div>
                  </details>
                } @else {
                  <div class="multi-select multi-select--disabled">
                    Select a PSS first
                  </div>
                }
                <small>Select a PSS first; only its Links are available.</small>
              </div>
              <div class="form-field">
                Contract(s) / Flow Area Source
                @if (selectedPssCode()) {
                  <details
                    class="multi-select"
                    [open]="isMultiSelectOpen('contracts')"
                    (toggle)="setMultiSelectOpen('contracts', $any($event.target).open)"
                    (focusout)="closeMultiSelectOnFocusOut('contracts', $event)"
                  >
                    <summary>{{ contractSelectionLabel() }}</summary>
                    <div class="multi-select__menu">
                      @for (contract of contractsForPss(); track contract.id) {
                        <label
                          ><input
                            type="checkbox"
                            [checked]="
                              form.controls.contractIds.value.includes(
                                contract.id
                              )
                            "
                            (change)="
                              toggleContract(
                                contract.id,
                                $any($event.target).checked
                              )
                            "
                          /><span
                            >{{ contract.buyerName }} ·
                            {{ contract.contractType }} ·
                            {{ contract.contractCapacityMw }} MW</span
                          ></label
                        >
                      } @empty {
                        <p>No contract mappings for this PSS.</p>
                      }
                    </div>
                  </details>
                } @else {
                  <div class="multi-select multi-select--disabled">
                    Select a PSS first
                  </div>
                }
                <small>Read from Contract Mapping for the selected PSS.</small>
              </div>
              <label
                >Purpose of Path <b>*</b
                ><select class="app-form-select" formControlName="purpose">
                  <option value="">Select purpose</option>
                  <option>Curtailment</option>
                  <option>Moderation of Curtailment</option>
                  <option>Curtailment, Moderation of Curtailment</option>
                  <option>WRLDC WBES Data Sharing</option>
                </select></label
              >
            </div>
            <label class="data-sharing"
              >Used for Data Sharing <b>*</b
              ><span class="radio-row"
                ><input
                  type="radio"
                  formControlName="usedForDataSharing"
                  [value]="true"
                />
                Yes
                <input
                  type="radio"
                  formControlName="usedForDataSharing"
                  [value]="false"
                />
                No</span
              ><small>Used for WRLDC WBES data sharing</small></label
            >
          </section>
          <section>
            <h3>Audit Information</h3>
            <div class="form-grid three">
              <label
                >Effective From Date <b>*</b
                ><input
                  class="app-form-input"
                  type="date"
                  formControlName="effectiveFrom" /></label
              ><label
                >Effective To Date<input
                  class="app-form-input"
                  type="date"
                  formControlName="effectiveTo"
                /><small>Optional; leave blank if not applicable</small></label
              ><label
                >Remarks<textarea
                  class="app-form-input"
                  formControlName="remarks"
                  placeholder="Enter Remarks (Optional)"
                ></textarea>
              </label>
            </div>
          </section>
          @if (formError()) {
            <p class="form-error" role="alert">{{ formError() }}</p>
          }
          <footer class="form-actions">
            <button
              type="button"
              class="app-button app-button--secondary"
              (click)="closeForm()"
            >
              Cancel</button
            ><button type="submit" class="app-button app-button--primary">
              Save
            </button>
          </footer>
        </form>
      </section>
    </div>
  }
</section>
